import { variables as argVariables } from './arg';
import { variables as extVariables } from './ext';

export const vars = (word) => {
    const pathname = window.location.pathname
    if(pathname.includes("exterior"))
        return extVariables[word]
    return argVariables[word] 
}